import React from 'react';
import loadingGif from '../../assets/loading.gif';

import { LoadingDiv } from './style';

const Loading = () => (
    <LoadingDiv>
        <img src={loadingGif} alt="loading..." />
    </LoadingDiv>
);

export default Loading;